<template>
  <Popup v-model="showPop" position="bottom">
    <div class="kyc-popup">
      <div class="kyc-popup__close" @click="close"><img src="@/assets/img/close.png" alt=""></div>
      <!-- Face Verification Only -->
      <template v-if="showFaceVerify">
        <div class="kyc-popup__title">{{ $t('kycPop.faceVerify') }}</div>
        <div class="kyc-popup__subtitle">{{ $t('kycPop.faceDesc') }}</div>
        <ul class="kyc-popup__bullets">
          <li>{{ $t('kycPop.faceBullet1') }}</li>
          <li>{{ $t('kycPop.faceBullet2') }}</li>
          <li>{{ $t('kycPop.faceBullet3') }}</li>
        </ul>
        <div class="kyc-popup__img-wrap">
          <div class="kyc-popup__img-item">
            <div class="kyc-popup__img-box">
              <img src="@/assets/img/u56.svg" alt="">
              <img src="@/assets/img/u57.svg" alt="" class="img-overlay">
            </div>
          </div>
        </div>
        <div class="kyc-popup__note">
<!--          <div class="kyc-popup__note-label">{{ $t('kycPop.faceNote') }}</div>-->
          <div class="kyc-popup__note-text">{{ $t('kycPop.faceEnvTip') }}</div>
        </div>
        <div class="kyc-popup__privacy">
          <van-checkbox v-model="privacyChecked" icon-size="22px">
<!--            {{ $t('kycPop.facePrivacy') }}<span class="privacy-link">{{ $t('kycPop.facePrivacyLink') }}</span>-->
            <template>
              {{ $t('kycPop.identityPrivacy1') }}
              <span class="privacy-link" :key="index" v-for="(ag, index) in agreements" @click="goToAgreement(ag)">{{ ag.title }}{{ index < agreements.length - 1 ? ', ' : '' }} </span>.
              {{ $t('kycPop.identityPrivacy4') }}
            </template>
          </van-checkbox>
        </div>
        <div class="kyc-popup__footer">
          <div class="btn-primary" :class="{ 'btn-disabled': !privacyChecked }" @click="startVerify">{{ $t('kycPop.faceBtn') }}</div>
        </div>
      </template>

      <!-- Identity Verification (OCR + Face) -->
      <template v-else>
        <div class="kyc-popup__title">{{ $t('kycPop.identityVerify') }}</div>
        <div class="kyc-popup__subtitle">{{ $t('kycPop.identityDesc') }}</div>
        <ul class="kyc-popup__bullets">
          <li>{{ $t('kycPop.identityBullet1') }}</li>
          <li>{{ $t('kycPop.identityBullet2') }}</li>
          <li>{{ $t('kycPop.identityBullet3') }}</li>
        </ul>
        <div class="kyc-popup__img-wrap">
          <div class="kyc-popup__img-item">
            <div class="kyc-popup__img-box">
              <img src="@/assets/img/u156.svg" alt="">
              <img src="@/assets/img/u157.svg" alt="" class="img-overlay">
            </div>
            <div class="kyc-popup__img-label">{{ $t('kycPop.identityStep1') }}</div>
          </div>
          <div class="kyc-popup__img-plus">+</div>
          <div class="kyc-popup__img-item">
            <div class="kyc-popup__img-box">
              <img src="@/assets/img/u56.svg" alt="" style="height: 65%;width: 65%">
              <img src="@/assets/img/u57.svg" alt="" class="img-overlay" style="max-height: 70%;max-width: 70%">
            </div>
            <div class="kyc-popup__img-label">{{ $t('kycPop.identityStep2') }}</div>
          </div>
        </div>
        <div class="kyc-popup__note">
          <div class="kyc-popup__note-label">{{ $t('kycPop.identityNote') }}</div>
          <div class="kyc-popup__note-text">{{ $t('kycPop.identityEnvTip') }}</div>
        </div>
        <div class="kyc-popup__privacy">
          <van-checkbox v-model="privacyChecked" icon-size="22px">
<!--            {{ $t('kycPop.identityPrivacy1') }}-->
<!--            <span class="privacy-link">{{ $t('kycPop.identityPrivacyLink') }}</span>-->
<!--            {{ $t('kycPop.identityPrivacy2') }}-->
<!--            {{ $t('kycPop.identityPrivacy3') }}-->
<!--            {{ $t('kycPop.identityPrivacy4') }}-->
            <template>
              {{ $t('kycPop.identityPrivacy1') }}
              <span class="privacy-link" :key="index" v-for="(ag, index) in agreements" @click="goToAgreement(ag)">{{ ag.title }}{{ index < agreements.length - 1 ? ', ' : '' }} </span>.
              {{ $t('kycPop.identityPrivacy4') }}
            </template>
          </van-checkbox>
        </div>
        <div class="kyc-popup__footer">
          <div class="btn-primary" :class="{ 'btn-disabled': !privacyChecked }" @click="startVerify">{{ $t('kycPop.identityBtn') }}</div>
        </div>
      </template>
    </div>
  </Popup>
</template>

<script>
import { Popup, Checkbox } from 'vant';
import {getAgreements} from "@/api/common";
import {AGREEMENT_SCENE} from "@/common/constants";
import agreement from "@/mixins/agreement";
export default {
  name: 'KycPopup',
  mixins: [agreement],
  components: {
    Popup,
    'van-checkbox': Checkbox
  },
  data() {
    return {
      showPop: false,
      privacyChecked: false,
      ocrStatus: '',
      kycStatus: '',
      authUrl: '',
      agreements: [],
    }
  },
  computed: {
    showFaceVerify() {
      const needOcr = ['OCR_STATUS_UNVERIFIED', 'OCR_STATUS_FAILED'].includes(this.ocrStatus);
      const needKyc = ['KYC_STATUS_REQUIRED', 'KYC_STATUS_NOT_PASSED'].includes(this.kycStatus);
      //return !needOcr || (needOcr && !needKyc);
      if (needOcr) {
        return false;
      }
      return needKyc;
    }
  },
  methods: {
    open({ ocrStatus, kycStatus, authUrl }) {
      this.ocrStatus = ocrStatus;
      this.kycStatus = kycStatus;
      this.authUrl = authUrl;
      this.privacyChecked = false;
      this.showPop = true;
      console.log("showPop")
      this.queryAgreements();
    },
    close() {
      this.showPop = false;
    },
    startVerify() {
      if (!this.privacyChecked) {
        return;
      }
      if (this.authUrl) {
        window.location.href = this.authUrl;
      }
    },
    queryAgreements() {
      getAgreements({
        sceneCode: AGREEMENT_SCENE.KYC
      }).then(res => {
        if (res.code === 'Success') {
          this.agreements = res.data.agreements || [];
        }
      });
    },
  }
}
</script>

<style lang="less">
.kyc-popup {
  padding: 40px 30px 50px;
  width: 750px;
  background: #FFFFFF;
  position: relative;
}
.van-popup {
  border-radius: 50px 50px 0px 0px !important;
}
</style>
<style lang="less" scoped>
.kyc-popup {
  &__close {
    position: absolute;
    right: 22px;
    top: 28px;
    width: 40px;
    height: 40px;

    img {
      margin: 8px auto;
      display: block;
      width: 24px;
      height: 24px;
    }
  }

  &__title {
    font-size: 36px;
    font-weight: 600;
    line-height: 50px;
    color: var(--text-color-black);
  }

  &__subtitle {
    margin-top: 30px;
    font-size: 26px;
    font-weight: 600;
    line-height: 38px;
    color: var(--text-color-black);
  }

  &__bullets {
    margin-top: 20px;
    padding-left: 0;
    list-style: none;

    li {
      position: relative;
      padding-left: 24px;
      font-size: 24px;
      line-height: 40px;
      color: var(--text-color-gray);

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 16px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--text-color-gray);
      }
    }
  }

  &__img-wrap {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 40px;
    padding: 0 20px;
  }

  &__img-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__img-box {
    position: relative;
    width: 250px;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;

      &:not(.img-overlay) {
        position: relative;
        z-index: 1;
      }
    }

    .img-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 105%;
      max-height: 105%;
      z-index: 2;
    }
  }

&__img-plus {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 250px;
    font-size: 40px;
    font-weight: 300;
    color: var(--text-color-gray);
  }

  &__img-label {
    margin-top: 12px;
    font-size: 22px;
    line-height: 30px;
    color: var(--text-color-gray);
    text-align: center;
  }

  &__note {
    margin-top: 40px;

    &-label {
      font-size: 26px;
      font-weight: 600;
      line-height: 36px;
      color: var(--text-color-black);
    }

    &-text {
      margin-top: 8px;
      font-size: 24px;
      line-height: 34px;
      color: var(--text-color-black);
    }
  }

  &__privacy {
    margin-top: 30px;
    font-size: 24px;
    line-height: 34px;

    .privacy-link {
      color: var(--link-color);
    }

    ::v-deep .van-checkbox {
      align-items: flex-start;
    }

    ::v-deep .van-checkbox__icon {
      margin-top: 4px;
      margin-right: 24px;
      padding: 6px;
    }

    ::v-deep .van-checkbox__label {
      font-size: 24px;
      line-height: 34px;
      color: var(--text-color-gray);
    }
  }

  &__footer {
    margin-top: 40px;
  }
}
</style>
